


























































































































































import { Component, Mixins } from 'vue-property-decorator'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import {
  deleteArviointityokalu,
  getArviointityokalu,
  palautaArviointityokalu
} from '@/api/tekninen-paakayttaja'
import AsiakirjatContent from '@/components/asiakirjat/asiakirjat-content.vue'
import ElsaButton from '@/components/button/button.vue'
import ElsaFormGroup from '@/components/form-group/form-group.vue'
import ElsaConfirmationModal from '@/components/modal/confirmation-modal.vue'
import ElsaFormMultiselect from '@/components/multiselect/multiselect.vue'
import ArviointityokaluLomakeKysymysForm from '@/forms/arviointityokalu-lomake-kysymys-form.vue'
import { Arviointityokalu, Asiakirja } from '@/types'
import { confirmExit } from '@/utils/confirm'
import { ArviointityokaluTila } from '@/utils/constants'
import { mapFile } from '@/utils/fileMapper'
import { toastFail, toastSuccess } from '@/utils/toast'

@Component({
  components: {
    ArviointityokaluLomakeKysymysForm,
    AsiakirjatContent,
    ElsaButton,
    ElsaConfirmationModal,
    ElsaFormGroup,
    ElsaFormMultiselect
  },
  validations: {
    form: {
      nimi: {
        required
      }
    }
  }
})
export default class ArviointityokaluView extends Mixins(validationMixin) {
  items = [
    {
      text: this.$t('etusivu'),
      to: { name: 'etusivu' }
    },
    {
      text: this.$t('arviointityokalut'),
      active: false
    },
    {
      text: this.$t('arviointityokalu'),
      active: true
    }
  ]

  form: Arviointityokalu = {
    id: -1,
    nimi: null,
    ohjeteksti: null,
    kategoria: null,
    kysymykset: [],
    liite: null,
    tila: ArviointityokaluTila.LUONNOS,
    kaytossa: true
  }

  asiakirjat: Asiakirja[] = []
  skipRouteExitConfirm = true
  deleting = false
  loading = false

  async mounted() {
    this.fetchArviointityokalu()
  }

  async fetchArviointityokalu() {
    try {
      this.form = (
        await getArviointityokalu(Number(this.$route?.params?.arviointityokaluId))
      ).data
      if (this.form.liite) {
        const data = Uint8Array.from(atob(this.form.liite.data), (c) => c.charCodeAt(0))
        this.asiakirjat.push(
          mapFile(
            new File([data], this.form.liitetiedostonNimi || '', {
              type: this.form.liitetiedostonTyyppi || ''
            })
          )
        )
      }
    } catch (err) {
      console.warn(err) // eslint-disable-line no-console
      toastFail(this, this.$t('arviointityokalun-hakeminen-epaonnistui'))
      this.$router.replace({ name: 'arviointityokalut' })
      this.loading = false
    }
  }

  async onCancel() {
    if (this.skipRouteExitConfirm || (await confirmExit(this))) {
      this.$v.form.$reset()
      this.skipRouteExitConfirm = true
      this.$emit('skipRouteExitConfirm', true)
    }
  }

  showDeleteConfirm() {
    this.$bvModal.show('confirm-dialog')
  }

  onCancelConfirm() {
    this.$emit('skipRouteExitConfirm', true)
  }

  async onArviointityokaluDelete() {
    try {
      if (this.form && this.form.id) {
        await deleteArviointityokalu(this.form.id)
        toastSuccess(this, this.$t('arviointityokalu-poistettu'))
        this.skipRouteExitConfirm = true
        this.$router.replace({ name: 'arviointityokalut' })
      }
    } catch {
      this.$router.replace({ name: 'arviointityokalut' })
    }
  }

  async palautaLuonnostilaan() {
    try {
      if (this.form && this.form.id) {
        const result = await palautaArviointityokalu(this.form.id)
        if (result.status === 200) {
          toastSuccess(this, this.$t('arviointityokalu-palautettu'))
        } else {
          toastFail(this, this.$t('arviointityokalu-palautus-epaonnistui'))
        }
        this.fetchArviointityokalu()
      }
    } catch {
      this.$router.replace({ name: 'arviointityokalut' })
    }
  }
}
